var exports = {
  "i": "ColorDecoratorMain__77qvk4",
};

module.exports = exports;
